// extracted by mini-css-extract-plugin
module.exports = {"Icon":"ActionsIcons_Icon__rTmGu"};